module.exports = {"361125001":"兴安街道","361125100":"岑阳镇","361125101":"葛源镇","361125200":"姚家乡","361125201":"莲荷乡","361125202":"司铺乡","361125203":"港边乡","361125204":"龙门畈乡","361125205":"青板乡","361125401":"红桥垦殖场","361125502":"上坑源林场","361125503":"山黄林场","361125504":"新篁"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361125.json
// module id = 1459
// module chunks = 0